import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from 'react-bootstrap';

import "./editAdminProfile.css";
import { sidebarNavItems, genderList, ROUTES, MESSAGE } from "../../../constant";
import SideBar from "../../commanComponents/sidebar/sidebar";
import { getCountryService, getStateService, getCityService, updateSchoolAdminProfileService, getSchoolAdminProfileService } from '../../../modules/services';
import InputDropdown from '../../commanComponents/inputDropdown/inputDropdown';
import TopNavigation from "../../commanComponents/topNavigation/topNavigation";
import TextInputField from '../../commanComponents/textInputField/textInputField';
import PrimaryButton from '../../commanComponents/primaryButton/primaryButton';
import { clearData, loadData, saveJsonData } from '../../../utils/localStorage';


const EditAdminProfile = (props) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [countryData, setCountryData] = useState([]);
    const [stateData, setstateData] = useState([]);
    const [cityData, setCityData] = useState([]);

    const loginSchema = z.object({
        //first_name
        first_name: z.string().min(1, { message: MESSAGE.THIS_REQUEIRED_FIELD.replace("{0}", "First Name") }),
        //last_name
        last_name: z.string().min(1, { message: MESSAGE.THIS_REQUEIRED_FIELD.replace("{0}", "Last Name") }),
        //dob
        dob: z.string(),
        //gender
        gender: z.string(),
        //phone
        phone: z.string(),
        //city
        city: z.string(),
        //state
        state: z.string(),
        //country
        country: z.string(),
        //pincode
        pincode: z.string(),
    });
    const { register, handleSubmit, control, setValue, getValues, formState: { errors } } = useForm({
        resolver: zodResolver(loginSchema)
    });

    const getCityDataService = useCallback((state) => {
        (async () => {
            const responseData = await getCityService({state: state});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setCityData(renderDropdownListData(responseData.data, true));
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }, []);

    const getStateDataService = useCallback((country, resData) => {
        (async () => {
            const responseData = await getStateService({country_id: country});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                const stateList = renderDropdownListData(responseData.data);
                setstateData(stateList);

                if (resData && resData.state) {
                    const activeState = stateList.filter(option => option.value === resData.state)[0]
                    if (activeState) {
                        getCityDataService(activeState.id);
                    }
                }
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }, [getCityDataService]);

    const getCountryDataService = useCallback((resData) => {
        (async () => {
            const responseData = await getCountryService({});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                const countryList = renderDropdownListData(responseData.data);
                setCountryData(countryList);
                if (resData.country) {
                    getStateDataService(countryList.filter(option => option.value === resData.country)[0].id, resData);
                }
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }, [getStateDataService]);


    useEffect(() => {
        (async () => {
            const responseData = await getSchoolAdminProfileService({});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                let data = Object.fromEntries(
                    Object.entries(responseData.data).map(([key, value]) => [key, value === null ? "" : value])
                );

                data.gender = data.gender.toUpperCase();

                setValue("first_name", data.first_name);
                setValue("last_name", data.last_name);
                setValue("dob", data.dob);
                setValue("gender", data.gender);
                setValue("phone", data.phone);
                setValue("country", data.country);
                setValue("state", data.state);
                setValue("city", data.city);
                setValue("pincode", data.pincode);

                getCountryDataService(responseData.data);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
        
    }, [getCountryDataService]);

    const renderDropdownListData = (listData, isCity=null) => {
        if (isCity) {
            return (listData.map(data =>({label:data.city,value:data.city, id: data.id})))
        }
        return (listData.map(data =>({label:data.name,value:data.name, id: data.id})))
    }
   
    const handleCountryChange = (country) => {
        getStateDataService(countryData.filter(option => option.value === country)[0].id);
    }

    const handleStateChange = (state) => {
        getCityDataService(stateData.filter(option => option.value === state)[0].id);
    }

    const handleUpdateUserSave = (data) => { 
            setIsLoading(true);
            (async () => {
                const responseData = await updateSchoolAdminProfileService(data, {});
                if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                    setIsLoading(false);
                    var userData = loadData("user");
                    userData = JSON.parse(userData);
                    userData.first_name = responseData.data.first_name;
                    userData.last_name = responseData.data.last_name;
                    saveJsonData("user", userData);
                    navigate(ROUTES.ADMIN_PROFILE);
                }
                else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {

                }
                else {
                    clearData();
                    navigate(ROUTES.LOGIN);
                }
            })();
    }

    return (
        <div className='edit-profile-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.profile} />
            <div className='edit-profile-side-container'>
                <TopNavigation activeItem={sidebarNavItems.profile} />
                
                <div className='row edit-profile-filter-container'>
                </div>
                
                <div className='edit-profile-main-container'>
                    <Form onSubmit={handleSubmit(handleUpdateUserSave)}>
                        <div className='row'>
                            <div className='col'>
                            <h5>Edit Profile</h5>
                            </div>
                            <div className='col edit-profile-header-right'>
                                <PrimaryButton
                                    type="submit"
                                    isLoading={isLoading}
                                    text="SAVE"
                                />
                            </div>
                        </div>
                        
                        <hr className="edit-profile-border" />
                        <div className='row edit-profile-input-row'>
                            <div className='col-sm'>
                                <TextInputField
                                    placeholder="First name"
                                    fieldType="text"
                                    errorMessage={errors.first_name?.message}
                                    inputKey="first_name"
                                    formRegister={register}
                                    maxWidth="400px"
                                />
                            </div>
                            <div className='col-sm'>
                                <TextInputField
                                    placeholder="Last Name"
                                    fieldType="text"
                                    errorMessage={errors.last_name?.message}
                                    inputKey="last_name"
                                    formRegister={register}
                                    maxWidth="400px"
                                />
                            </div>
                        </div>
                        <div className='row edit-profile-input-row'>
                            <div className='col-sm'>
                                <TextInputField
                                    placeholder="Date of Birth"
                                    fieldType="date"
                                    errorMessage={errors.dob?.message}
                                    inputKey="dob"
                                    formRegister={register}
                                    maxWidth="400px"
                                />
                            </div>
                            <div className='col-sm'>
                                <InputDropdown
                                    inputKey="gender"
                                    itemList={genderList}
                                    maxWidth="400px"
                                    placeholder="Gender"
                                    defaultValue={""}
                                    formRegister={control}
                                    errorMessage={errors.gender?.message}
                                />
                            </div>
                        </div>
                        <div className='row edit-profile-input-row'>
                            <div className='col-sm'>
                                <TextInputField
                                    placeholder="Phone number"
                                    fieldType="text"
                                    errorMessage={errors.phone?.errorMessage}
                                    inputKey="phone"
                                    formRegister={register}
                                    maxWidth="400px"
                                />
                            </div>
                            <div className='col-sm'>
                                <InputDropdown
                                    inputKey="country"
                                    itemList={countryData}
                                    maxWidth="400px"
                                    placeholder="Country"
                                    defaultValue={""}
                                    formRegister={control}
                                    errorMessage={errors.country?.message}
                                    onDropdownChange={handleCountryChange}
                                />
                            </div>
                        </div>
                        <div className='row edit-profile-input-row'>
                            <div className='col-sm'>
                                <InputDropdown
                                    inputKey="state"
                                    itemList={stateData}
                                    maxWidth="400px"
                                    placeholder="State"
                                    defaultValue={""}
                                    formRegister={control}
                                    errorMessage={errors.state?.message}
                                    onDropdownChange={handleStateChange}
                                />
                            </div>
                            <div className='col-sm'>
                                <InputDropdown
                                    inputKey="city"
                                    itemList={cityData}
                                    maxWidth="400px"
                                    placeholder="City"
                                    defaultValue={""}
                                    formRegister={control}
                                    errorMessage={errors.city?.message}
                                />
                            </div>
                        </div>
                        <div className='row edit-profile-input-row'>
                            <div className='col-sm'>
                                <TextInputField
                                    placeholder="Pincode"
                                    fieldType="text"
                                    errorMessage={errors.pincode?.errorMessage}
                                    inputKey="pincode"
                                    formRegister={register}
                                    maxWidth="400px"
                                />
                            </div>
                            <div className='col-sm'>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
 }


export default EditAdminProfile;
